<template>
    <v-row>
        <v-col cols="12">
            <v-form>
                <v-container>
                <v-row>
                    <v-col cols="12" sm="6" md="4" lg="3">
                    <v-select
                    :items="terms"
                    item-text="term_session"
                    item-value="parameter_id"
                    @change="fetchStudents()" 
                    label="Select Term:"
                    v-model="form.parameter_id"
                    outlined
                    dense
                    :rules="[v => !!v || 'Term need to be selected!']"
                    required
                    ></v-select>
                    </v-col>

                    <v-col cols="12" sm="6" md="4" lg="3">
                        <v-select
                        :items="classes"
                        item-text="class"
                        item-value="class_id"
                        label="Select Class:"
                        v-model="form.clasx_id"
                        outlined
                        dense
                        :rules="[v => !!v || 'Class need to be selected!']"
                        required
                        @change="fetchStudents()"
                        ></v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" lg="3" v-if="!accessToken">
                        <v-select
                        :items="students"
                        item-text="name"
                        item-value="scs_id"
                        @change="emitForm" label="Select Student (optional):"
                        v-model="form.scs_id" 
                        dense
                        outlined
                        clearable
                        placeholder="Leave blank to select all students in class"
                        ></v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" lg="3" v-if="!accessToken">
                        <v-select
                    
                        :items="templates.filter((template) => {
                            return template.schid === school.school_id
                        })"
                        item-text="name"
                        item-value="id"
                        @change="emitForm" label="Use Custom Template:"
                        v-model="rsettings.template"
                        outlined
                        dense
                        ></v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" lg="3">
                        <v-select
                    
                        :items="['Preview', 'Full']" 
                        label="Print Mode"
                        v-model="form.printMode"
                        outlined
                        @change="emitForm"
                        dense
                        :disabled="userType == 'Student'"
                        ></v-select>
                    </v-col>
                </v-row>
                </v-container>
            </v-form>
        </v-col>
    </v-row>
</template>

<script>
import axios from 'axios';
export default {
    name: 'SelectionForm',
    props:[
        'authToken', 
        'accessToken', 
        'userType',
        'school',
        'terms',
        'classes',
        'templates',
    ],
    data () {
        return {
            rsettings:localStorage.getItem('school') ? JSON.parse(localStorage.getItem('school')).settings : {},
            form: {
                parameter_id: this.terms.length > 0 ? this.terms[0].parameter_id : null,
                printMode: this.userTypePrintMode
            },
            students: [],
            subjects: [],
            tokensUsed: 0
        }
    },
    created() {
        this.form.printMode = this.getUserTypePrintMode();
    },
    computed:{
        //
    },
    metaInfo: {
        meta: [
            { name: 'viewport', content: 'width=device-width,initial-scale=1.0' }
        ]
    },
    mounted() {
        this.fetchUpdatedSchoolSetting()
    },
    methods:{
        getUserTypePrintMode() {
            return this.userType === 'Student' ? 'Full' : 'Preview';
        },
        emitForm (){
            if (this.form.parameter_id && this.form.clasx_id && this.form.printMode) { 
                this.$emit('settings', [{settings:this.rsettings, form:this.form}])
            }
        },
        fetchStudents (){
            if (this.form.parameter_id && this.form.clasx_id) { 
                let loader = this.$loading.show()
                axios.get(process.env.VUE_APP_BASEURL+'/students?school_id='+this.school.school_id+'&class_id='+this.form.clasx_id+'&parameter_id='+this.form.parameter_id,
                {
                    headers: 
                    {
                        'Authorization': 'Bearer '+this.authToken,
                        'X-Access-Token': this.accessToken,
                    }
                })
                .then((response) => {
                    this.students =  response.data.data
                    this.form.scs_id = null
                    this.$emit('students', this.students) 
                    if (this.students.length == 0) {
                        this.$toast.info('No Students in selected class. ADD or PROMOTE students to class!', {
                                timeout: 5000
                            }); 
                        this.$router.push({name: 'Students'})
                    }  
                })
                .catch((error) => {
                    console.log(error)
                })
                .finally(() => {
                    this.emitForm()
                    loader.hide()
                });
            }    
        },

        fetchUpdatedSchoolSetting (){
            axios.get(process.env.VUE_APP_BASEURL+'/settings?school_id='+this.school.school_id,
            {
                headers: 
                {
                    'Authorization': 'Bearer '+this.authToken,
                    'X-Access-Token': this.accessToken,
                }
            })
            .then((response) => {
                localStorage.school =  JSON.stringify(response.data.data)
            })
            .catch((error) => {
                console.log(error)
            })
            .finally(() => {
                this.emitForm()
            });   
        },
    }
}
</script>

<style scoped>
</style>
